import { ref, InjectionKey } from "vue";

export const GlobalMethodsKey: InjectionKey<GlobalMethods> =
  Symbol("GlobalMethods");

export interface GlobalMethods {
  host: string;
  getHost: () => string;
}

export function useGlobalMethods(): GlobalMethods {
  const host = "sav.meuble-promo.fr";

  function getHost() {
    const currentUrl = window.location.href;
    const hostname = new URL(currentUrl).hostname;
    return hostname;
  }

  return {
    host,
    getHost,
  };
}
